module.exports = __webpack_public_path__ + "static/Mubi_logo-8b6f42b6e34bbbb55d5eed2653ea6cc4.png";